import './App.css';
import Header from './components/Header/Header';
import PlayerSelector from './components/PlayerSelector/PlayerSelector';

function App() {
  return (
    <div >
      <Header></Header>
      <PlayerSelector ></PlayerSelector>
      
    </div>
  );
}

export default App;
